import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.49222 2.22208C3.54174 2.95669 3.66555 3.67478 3.86365 4.35986L2.87317 5.35034C2.53476 4.35986 2.32015 3.31161 2.24587 2.22208H3.49222ZM11.6306 12.1434C12.3322 12.3414 13.0503 12.4653 13.7767 12.5148V13.7446C12.6871 13.6703 11.6389 13.4557 10.6402 13.1256L11.6306 12.1434ZM4.2846 0.571289H1.39571C0.941741 0.571289 0.570312 0.942718 0.570312 1.39669C0.570312 9.14716 6.85158 15.4284 14.6021 15.4284C15.056 15.4284 15.4275 15.057 15.4275 14.603V11.7224C15.4275 11.2684 15.056 10.897 14.6021 10.897C13.5786 10.897 12.5798 10.7319 11.6554 10.4265C11.5729 10.3935 11.4821 10.3853 11.3995 10.3853C11.1849 10.3853 10.9786 10.4678 10.8135 10.6246L8.99761 12.4405C6.66174 11.2437 4.74682 9.337 3.55825 7.00113L5.37412 5.18526C5.60523 4.95415 5.67126 4.63224 5.58047 4.34335C5.27507 3.41891 5.10999 2.42843 5.10999 1.39669C5.10999 0.942718 4.73857 0.571289 4.2846 0.571289Z"
      fill="white"
    />
  </svg>
);
export default SVGComponent;
